class FirmwareRequestDto {
  /** 固件编号 */
  code = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 */
  deleted = undefined;

  /** 固件描述 */
  description = "";

  /** id */
  id = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 固件名称 */
  name = "";

  /** 状态 1:正常 2:停用 */
  status = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class FirmwareResponseDto {
  /** 固件编号 */
  code = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 */
  deleted = undefined;

  /** 固件描述 */
  description = "";

  /** id */
  id = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 固件名称 */
  name = "";

  /** 状态 1:正常 2:停用 */
  status = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class FirmwareVersionAppResponseDto {
  /** app版本号 */
  appVersion = "";

  /** app版本描述 */
  appVersionDescription = "";

  /** 固件版本编号 */
  code = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 */
  deleted = undefined;

  /** 固件版本描述 */
  description = "";

  /** 固件URL */
  fileUrl = [];

  /** 固件编号 */
  firmwareCode = "";

  /** 是否强制升级 1是，0否 */
  forcedUpgrade = false;

  /** id */
  id = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 最小固件版本号 */
  minFirmwareVersion = "";

  /** 固件版本名称 */
  name = "";

  /** 文档URL */
  note = [];

  /** 状态 1:正常 2:停用 */
  status = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 版本号 */
  version = "";

  /** 版本日期 */
  versionDate = "";
}

class FirmwareVersionItemRequestDto {
  /** 固件地址 */
  fileUrl = "";

  /** 固件本版 */
  firmwareCode = "";

  /** 主表ID */
  firmwareVersionId = undefined;

  /** 是否强制升级 1是，0否 */
  forcedUpgrade = false;

  /** id */
  id = undefined;

  /** 最大硬件版本号 */
  maxHardwareVersion = "";

  /** 最小固件版本号 */
  minFirmwareVersion = "";

  /** 最小硬件版本号 */
  minHardwareVersion = "";

  /** 文档地址 */
  note = "";

  /** 是否默认 1:是 2:否 */
  preset = false;

  /** 状态 1:正常 2:停用 */
  status = undefined;

  /** 固件版本 */
  version = "";

  /** 版本日期 */
  versionDate = "";
}

class FirmwareVersionItemResponseDto {
  /** 固件地址 */
  fileUrl = [];

  /** 固件 */
  firmwareCode = "";

  /** 主表ID */
  firmwareVersionId = undefined;

  /** 是否强制升级 1是，0否 */
  forcedUpgrade = false;

  /** id */
  id = undefined;

  /** 最大硬件版本号 */
  maxHardwareVersion = "";

  /** 最小固件版本号 */
  minFirmwareVersion = "";

  /** 最小硬件版本号 */
  minHardwareVersion = "";

  /** 文档地址 */
  note = [];

  /** 是否默认 1:是 2:否 */
  preset = false;

  /** 状态 1:正常 2:停用 */
  status = undefined;

  /** 版本号 */
  version = "";

  /** 版本日期 */
  versionDate = "";
}

class FirmwareVersionRequestDto {
  /** app版本号 */
  appVersion = "";

  /** app版本描述 */
  appVersionDescription = "";

  /** 固件版本编号 */
  code = "";

  /** 固件版本描述 */
  description = "";

  /** id */
  id = undefined;

  /** 版本信息数组 */
  item = [];

  /** 固件版本名称 */
  name = "";
}

class FirmwareVersionResponseDto {
  /** app版本号 */
  appVersion = "";

  /** app版本描述 */
  appVersionDescription = "";

  /** 固件版本编号 */
  code = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 */
  deleted = undefined;

  /** 固件版本描述 */
  description = "";

  /** id */
  id = undefined;

  /** 版本信息数组 */
  item = [];

  /** 乐观锁 */
  lockVersion = undefined;

  /** 固件版本名称 */
  name = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class IPage {
  /** current */
  current = undefined;

  /** hitCount */
  hitCount = false;

  /** pages */
  pages = undefined;

  /** records */
  records = [];

  /** searchCount */
  searchCount = false;

  /** size */
  size = undefined;

  /** total */
  total = undefined;
}

class OssFile {
  /** 名称 */
  name = "";

  /** url */
  url = "";
}

class Response {
  /** code */
  code = "";

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class ResponseDto {
  /** code */
  code = "";

  /** data */
  data = new FirmwareVersionAppResponseDto();

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class SkuFirmwareRequestDto {
  /** 关联编号 */
  associationCode = "";

  /** 关联类型 1：固件，2：固件版本（同固件，指定固件版本优先级更高） */
  associationType = undefined;

  /** 品牌 */
  brand = "";

  /** sku固件编号 */
  code = "";

  /** 创建人 */
  createBy = "";

  /** id */
  id = undefined;

  /** 名称 */
  name = "";

  /** sku */
  sku = "";

  /** spu */
  spu = "";

  /** 状态 1:正常 2:停用 */
  status = undefined;

  /** sku中文名称 */
  titleCn = "";

  /** sku英文名称 */
  titleEn = "";

  /** 更新人 */
  updateBy = "";
}

class SkuFirmwareResponseDto {
  /** 关联编号 */
  associationCode = "";

  /** 关联类型 1：固件，2：固件版本（同固件，指定固件版本优先级更高） */
  associationType = undefined;

  /** 品牌 */
  brand = "";

  /** sku固件编号 */
  code = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 名称 */
  name = "";

  /** sku */
  sku = "";

  /** spu */
  spu = "";

  /** 状态 1:正常 2:停用 */
  status = undefined;

  /** sku中文名称 */
  titleCn = "";

  /** sku英文名称 */
  titleEn = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

export const device = {
  FirmwareRequestDto,
  FirmwareResponseDto,
  FirmwareVersionAppResponseDto,
  FirmwareVersionItemRequestDto,
  FirmwareVersionItemResponseDto,
  FirmwareVersionRequestDto,
  FirmwareVersionResponseDto,
  IPage,
  OssFile,
  Response,
  ResponseDto,
  SkuFirmwareRequestDto,
  SkuFirmwareResponseDto,
};
